
import { xfer_firm_name } from "./onboarding-tda/TDA_holding_firm_menu";
import { sprintf } from "sprintf-js";
import { is_ira_type } from "./constants";
import { InvestmentAccountType } from "./proto/investment_accounts";
import { strip_prefix } from "./prm/utils";
import { DtcClearingMembers } from "./onboarding-tda/dtc_clearing_members";
import {date_to_sec, get_now_sec, SECONDS_PER_YEAR } from "./time";
import {PERSHING_FIRST_ENDPOINT} from "./onboarding-pershing/flows";
import {TDA_FIRST_ENDPOINT} from "./onboarding-tda/flows";
import {HYPERVERGE_STATE} from "./hyperverge-constants";

const CLIENT_SIGNER = "Client";
const JOINT_SIGNER = "Joint";

const calc_account_type = onboarding => {

  // If there is no 'invest_for', then assume regular taxable investment
  if (!onboarding.invest_for) {
    return InvestmentAccountType.individual;
  }

  const acct_type = onboarding.invest_for[0].split("|")[1];

  if (acct_type === "custodial") {
    const cust_type = strip_prefix(onboarding.custodial_type);
    if (cust_type === "trust") {
      return InvestmentAccountType.ugma_utma;
    } else if (cust_type === "roth") {
      return InvestmentAccountType.custodial_ira;
    }
    console.log("Error ZZ");
  } else if (acct_type === "IRA") {
    const ira_type = onboarding.ira_type[0].split("|")[1];
    if (ira_type === "traditional") {
      return InvestmentAccountType.ira;
    } else if (ira_type === "spousal") {
      return InvestmentAccountType.spousal_ira;
    } else if (ira_type === "roth") {
      return InvestmentAccountType.roth_ira;
    } else if (ira_type === "custodial") {
      return InvestmentAccountType.custodial_ira;
    } else if (ira_type === "rollover") {
      return InvestmentAccountType.rollover_ira;
    }
    console.log("Error A");
  } else if (acct_type === "IRA_rollover") {
    return InvestmentAccountType.rollover_ira;
  } else if (acct_type === "standard_invest_0" || acct_type === "standard_invest_1") {
    const invest_type = onboarding.invest_type;
    if (invest_type === "individual") {
      return InvestmentAccountType.individual;
    } else if (invest_type === "spouse" || invest_type === "tenants_in_common") {
      return InvestmentAccountType.joint;
    }
    console.log("Error B");
  } else if (acct_type === "transfer") {
    const xfer_acct_type = onboarding.xfer_acct_type[0].split("|")[1];
    if (xfer_acct_type === "individual") {
      return InvestmentAccountType.individual;
    } else if (xfer_acct_type === "joint_spouse"
      || xfer_acct_type === "joint_tenants"
      || xfer_acct_type === "tenants_common") {
      return InvestmentAccountType.joint;
    } else if (xfer_acct_type === "ira") {
      const xfer_ira_type = onboarding.xfer_ira_type[0].split("|")[1];

      if (xfer_ira_type === "traditional_ira") {
        return InvestmentAccountType.ira;
      } else if (xfer_ira_type === "rollover_ira") {
        return InvestmentAccountType.rollover_ira;
      } else if (xfer_ira_type === "roth_ira") {
        return InvestmentAccountType.roth_ira;
      } else if (xfer_ira_type === "sepp_ira") {
        return InvestmentAccountType.sepp_ira;
      } else if (xfer_ira_type === "simple_ira") {
        return InvestmentAccountType.simple_ira;
      }
      console.log("Error C");
    } else if (xfer_acct_type === "ira_roth") {
      return InvestmentAccountType.roth_ira;
    } else if (xfer_acct_type === "trust") {
      return InvestmentAccountType.ugma_utma;
    }
    console.log("Error D");
  }
  console.log("calc_account_type ERROR");
  return InvestmentAccountType.ACCOUNT_TYPE_UNDEFINED;
};

const is_custodial = onboarding => {
  const acct_type = onboarding.account_type;
  return acct_type === InvestmentAccountType.ugma_utma.id
    || acct_type === InvestmentAccountType.custodial_ira.id
    || acct_type === InvestmentAccountType.a_529.id;
}

const is_ugma = (onboarding) => {
  return onboarding.account_type === InvestmentAccountType.ugma_utma.id;
};

const get_invest_for = onboarding => {
  return strip_prefix(onboarding.invest_for);
}


const is_ira = (onboarding) => {
  const invest_For = strip_prefix(onboarding.invest_for);

  if (invest_For === "IRA" || invest_For === "IRA_rollover") {
    return true;
  }

  if (invest_For === 'transfer') {
    const xfer_acct_type = strip_prefix(onboarding.xfer_acct_type);
    return xfer_acct_type === "ira_rollover";
  }

  return false;
}

const is_ira_rollover = onboarding => {
  return strip_prefix(onboarding.invest_for) === "IRA_rollover";
}

const get_payment_choice = onboarding => {
  return strip_prefix(onboarding.payment_choice);
}

const get_transfer_firm_label = onboarding => {

  let val = onboarding.xfer_firm_name;
  if (!val) {
    return null;
  }

  // Fidelity is really handled by National Financial Services
  if (val === 'fidelity') {
    val = 'national_financial';
  }

  return xfer_firm_name.menu.find(item => item.id === val).label;
};

const get_dtc_clearing_firm_label = onboarding => {
  const firm_id = onboarding.dtc_firm_menu;
  if (!firm_id) {
    return null;
  }
  if (!(firm_id in DtcClearingMembers)) {
    throw new Error("Can't find " + firm_id + " in DtcClearing");
  }
  return DtcClearingMembers[firm_id].label;
};

const is_transfer = onboarding => {
  return strip_prefix(onboarding.invest_for) === "transfer";
};

const role_titles = onboarding => {
  if (!onboarding.ROLE_TITLES) {
    return ["Individual"];
  }
  return onboarding.ROLE_TITLES;
}

const calc_roles_old = (onboarding) => {
  let {invest_for, invest_type, xfer_acct_type} = onboarding;

  invest_for = strip_prefix(invest_for);
  xfer_acct_type = strip_prefix(xfer_acct_type);

  // UGMA Trust
  if (invest_for === 'trust'
    || (invest_for === 'transfer' && xfer_acct_type === 'trust')) {

    return [ "Your Information", "Child" ];
  }

  // Married
  if ((invest_for === 'standard_invest_0' && invest_type === "spouse")
    || (invest_for === 'standard_invest_1' && invest_type === "spouse")
    || (invest_for === 'transfer' && xfer_acct_type === 'joint_spouse')) {
    return [ "Your Information", "Your Spouse's Information"];
  }

  // Tennants in common
  if ((invest_for === 'standard_invest_0' && invest_type === 'tenants_in_common')
    || (invest_for === 'standard_invest_1' && invest_type === 'tenants_in_common')
    || (invest_for === 'transfer' && xfer_acct_type === 'joint_tenants')
    || (invest_for === 'transfer' && xfer_acct_type === 'tenants_common')) {
    return ['Your Information', 'Other Owner'];
  }

  return ['Individual'];
};

const has_joint_role = onboarding => {
  return calc_roles_old(onboarding).length === 2;
}

const role_signer_mapping = onboarding => {

  if (is_ugma(onboarding)) {
    return [
      { role: 0, signer: CLIENT_SIGNER, is_minor: false },
    ]
  }

  const num_roles = calc_roles_old(onboarding).length;

  const mapping = [
    { role: 0, signer: CLIENT_SIGNER, is_minor: is_ugma(onboarding) },
  ];

  if (num_roles === 2) {
    mapping.push({
      role: 1, signer: JOINT_SIGNER, is_minor: false
    })
  }

  return mapping;
};

const get_client_role = onboarding => {
  return role_signer_mapping(onboarding)[0];
};

const get_joint_role = onboarding => {
  const signers = role_signer_mapping(onboarding);
  if (signers.length === 1) {
    throw new Error("Requesting joint signer with one role");
  }
  return signers[1];
}

const signer_to_role = (onboarding, signer) => {
  if (signer === CLIENT_SIGNER) {
    return get_client_role(onboarding);
  }
  if (signer === JOINT_SIGNER) {
    return get_joint_role(onboarding);
  }

  throw new Error("Unknown signer " + signer);
};

/**
 * Calculate the name, email, and username for a signing.
 *
 * @param onboarding {obj}
 * @param signer {String} [Client|Joint]
 * @return {{
 *  name: string,
 *  email: string,
 *  username: string,
 *  sms_number: string }}
 */
const get_signer_info = (onboarding, signer) => {
  const { role } = signer_to_role(onboarding, signer);
  const role_prefix = sprintf("role_%d", role);
  return {
    name: onboarding[role_prefix + "_first_name"] + " "
      + onboarding[role_prefix + "_last_name"],
    email: onboarding[role_prefix + "_email"],
    username: onboarding.username,
    sms_number: onboarding[role_prefix + "_phone_number"],
  }
};

/**
 * @param onboarding {Object}
 * @param all_gov_data {Object}
 * @return Income cap in dollars, or -1 if there is none.
 */
const get_ira_income_cap = (onboarding, all_gov_data) => {
  const acct_type = calc_account_type(onboarding);
  if (!is_ira_type(acct_type)) {
    return -1;
  }

  let gov = null;

  if (acct_type.id === "ira") {
    gov = all_gov_data.traditional_ira;
  } else if (acct_type.id === "roth_ira") {
    gov = all_gov_data.roth_ira;
  } else if (acct_type.id === "rollover_ira") {
    gov = all_gov_data.rollover_ira;
  }

  if (!gov) {
    return -1;
  }

  const filing_status = strip_prefix(onboarding.filing_status);

  if (!filing_status) {
    return -1;
  }

  return gov.earned_income_cap[filing_status].dollar;
};

/**
 * Takes dob_date, adds 72.5 years, subtracts the current date, to get the
 * number of years to IRA maturity.
 * @param dob_date {Date}
 * @returns {int} spend years
 */
const calc_ira_spend_years = (dob_date) => {
  const dob_sec = date_to_sec(dob_date);
  const current_date_sec = get_now_sec();
  const _72_5_years_sec = SECONDS_PER_YEAR * 72.5;
  const delta_sec = dob_sec + _72_5_years_sec - current_date_sec;
  return Math.round(delta_sec / SECONDS_PER_YEAR);
}

const onboarding_start_segment = (wlf, onboarding) => {
  if (wlf.custodian === "PERSHING") {

    if (onboarding && onboarding.hyperverge
      && onboarding.hyperverge.state === HYPERVERGE_STATE.KYC) {
      return "personal_info";
    }
    if (onboarding && onboarding.kyc_switch === "no_kyc") {
      return "personal_info";
    }
    return PERSHING_FIRST_ENDPOINT;
  }
  return TDA_FIRST_ENDPOINT;
}

export { is_ugma, get_transfer_firm_label, is_transfer, calc_roles_old,
  role_signer_mapping, get_client_role, get_joint_role, signer_to_role,
  CLIENT_SIGNER, JOINT_SIGNER, get_signer_info, is_ira,
  calc_account_type, get_ira_income_cap, get_payment_choice,
  is_ira_rollover, get_dtc_clearing_firm_label, calc_ira_spend_years,
  get_invest_for, has_joint_role, onboarding_start_segment, role_titles,
  is_custodial };
